import { FrameForm as FrameFormCore, FrameTriggerLoader } from '@studiometa/ui';
import Dropdown from './Dropdown.js';
import Reset from './Reset.js';
import { gsap } from 'gsap';

/**
 * @typedef {{}} ListingFormProps
 */

/**
 * ListingForm ListingForm.
 * @augments {Base<ListingFormProps>}
 */
export default class FrameForm extends FrameFormCore {
  mobileContainerIsOpen = false;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'FrameForm',
    refs: [
      'resetFilters',
      'btnReset',
      'btnMobile',
      'filtersContainer',
      'overlay',
      ...FrameFormCore.config.refs,
    ],
    components: {
      Dropdown,
      Reset,
      FrameTriggerLoader,
    },
  };

  /**
   *
   */
  mounted() {
    this.reset = this.$children.Reset[0];
    this.dropdownElements = this.$children.Dropdown.map((dropdown) => dropdown.$el);
  }

  /**
   *
   * @param {*} param0
   */
  onBtnMobileClick({ event }) {
    event.stopPropagation();
    if (this.mobileContainerIsOpen) {
      this.closeMobileContainer();
    } else {
      this.openMobileContainer();
    }
  }

  /**
   *
   * @param {*} param0
   */
  onFiltersContainerClick({ event }) {
    event.stopPropagation();
  }

  /**
   * Close
   */
  onDocumentClick() {
    if (this.mobileContainerIsOpen) {
      this.closeMobileContainer();
    }
  }

  /**
   *
   */
  openMobileContainer() {
    document.documentElement.classList.add('is-scrolling-down');
    const tl = gsap.timeline();
    tl.to(this.$refs.overlay, {
      duration: 0.6,
      opacity: 1,
      ease: 'power4.out',
      onStart: () => {
        this.$refs.overlay.classList.remove('pointer-events-none');
      },
    });

    tl.to(
      this.$refs.filtersContainer,
      {
        height: 'auto',
        duration: 0.7,
        ease: 'power4.inOut',
        onComplete: () => {
          this.$refs.filtersContainer.classList.remove('overflow-hidden');
        },
      },
      '<+=0',
    );

    tl.fromTo(
      this.dropdownElements,
      {
        opacity: 0,
        y: 40,
      },
      {
        opacity: 1,
        y: 0,
        stagger: {
          each: 0.1,
        },
      },
      '<+=0.4',
    );
    this.mobileContainerIsOpen = true;
    this.$refs.btnMobile.querySelector('span').innerHTML = this.$refs.btnMobile.dataset.close;
  }

  /**
   *
   */
  closeMobileContainer() {
    document.documentElement.classList.remove('is-scrolling-down');
    gsap.to(this.$refs.filtersContainer, {
      height: 0,
      duration: 0.4,
      ease: 'power3.inOut',
      onStart: () => {
        this.$refs.filtersContainer.classList.add('overflow-hidden');
      },
    });

    gsap.to(this.$refs.overlay, {
      duration: 0.4,
      opacity: 0,
      ease: 'power4.out',
      onComplete: () => {
        this.$refs.overlay.classList.add('pointer-events-none');
      },
    });
    this.mobileContainerIsOpen = false;
    this.$refs.btnMobile.querySelector('span').innerHTML = this.$refs.btnMobile.dataset.default;
  }

  /**
   *
   */
  onChange() {
    this.showReset = false;

    for (const el of this.$children.Dropdown) {
      if (el.inputHasValue) {
        this.showReset = true;
        break;
      }
    }

    if (this.showReset && !this.reset.isVisible) {
      this.$children.Reset[0].show();
    }
    if (!this.showReset && this.reset.isVisible) {
      this.$children.Reset[0].hide();
    }
  }

  /**
   *
   */
  onResetClick() {
    this.resetAllDropdown();
    this.$el.requestSubmit();
  }

  /**
   * When travelers dropdown opened
   * @param {object} props params
   * @param {Array}  props.args current element
   * @returns {void}
   */
  onDropdownOpen({ args }) {
    this.closeAllDropdown(args[0]);
  }

  /**
   * Close all dropdown expect element in param
   * @param  {object} component current Element
   * @returns {void}
   */
  closeAllDropdown(component) {
    this.$children.Dropdown.forEach((element) => {
      if (element !== undefined && element.$id !== component.$id) {
        element.close();
      }
    });
  }

  /**
   *
   */
  resetAllDropdown() {
    this.$children.Dropdown.forEach((element) => {
      element.resetDropdown();
    });
  }
}
